import React from "react";
import { CSVLink } from "react-csv";
import { Table } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

function generateCSVDataModel(seriesData) {
  return seriesData.map((entry) => ({
    Symbol: entry.symbol,
    Action: entry.action,
    "Action At": new Date(entry.timestamp).toLocaleString(),
    Description: entry.description,
  }));
}

const ModelEventLogsTable = ({ eventLogs }) => {
  const columns = [
    { title: "Symbol", dataIndex: "symbol", key: "symbol" },
    { title: "Action", dataIndex: "action", key: "action" },
    {
      title: "Action At",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (timestamp) => new Date(timestamp).toLocaleString(),
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.timestamp) - new Date(b.timestamp),
    },
    { title: "Description", dataIndex: "description", key: "description" },
  ];

  const csvData = generateCSVDataModel(eventLogs);

  return (
    <>
      <CSVLink data={csvData} filename={`ModelEventLogs-${new Date().toISOString()}.csv`} separator=";">
        <DownloadOutlined style={{ marginRight: 5 }} />
        Download csv
      </CSVLink>
      <Table rowKey="timestamp" bordered dataSource={eventLogs} columns={columns} pagination={{ pageSize: 10 }} />
    </>
  );
};

export default ModelEventLogsTable;
